import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerTokenService } from '../../services/server-token.service';
import {
  CreateInternalDeclineReasonResponse,
  DeleteInternalDeclineReasonResponse,
  InternalDeclineReason,
  InternalDeclineReasonListResponse,
  UpsertInternalDeclineReasonPayload,
} from './internal-decline-reasons.interface';

@Injectable({ providedIn: 'root' })
export class InternalDeclineReasonsService {
  private readonly basePath = 'snfs/internal-reasons/admin';

  constructor(private server: ServerTokenService) {}

  getReasons(): Observable<InternalDeclineReasonListResponse> {
    return this.server.getWithToken<InternalDeclineReasonListResponse>(this.basePath);
  }

  createReason(payload: UpsertInternalDeclineReasonPayload): Observable<CreateInternalDeclineReasonResponse> {
    return this.server.postWithToken<CreateInternalDeclineReasonResponse>(this.basePath, payload);
  }

  renameReason(
    reasonId: string,
    payload: UpsertInternalDeclineReasonPayload,
  ): Observable<InternalDeclineReason> {
    return this.server.putWithToken<InternalDeclineReason>(`${this.basePath}/${reasonId}`, payload);
  }

  deleteReason(reasonId: string): Observable<DeleteInternalDeclineReasonResponse> {
    return this.server.deleteWithToken<DeleteInternalDeclineReasonResponse>(`${this.basePath}/${reasonId}`);
  }

  setEnabled(enabled: boolean): Observable<{ enabled: boolean }> {
    return this.server.putWithToken<{ enabled: boolean }>(`${this.basePath}/settings`, { enabled });
  }
}
